var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5 26.6667C63.1522 26.6667 65.6957 27.7203 67.5711 29.5957C69.4464 31.471 70.5 34.0146 70.5 36.6667C70.5 39.3189 69.4464 41.8625 67.5711 43.7378C65.6957 45.6132 63.1522 46.6667 60.5 46.6667",
    stroke: "#F6CA4A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.834 26.6667V63.3334C33.834 64.2175 33.4828 65.0653 32.8577 65.6904C32.2326 66.3156 31.3847 66.6667 30.5007 66.6667H27.1673C26.2833 66.6667 25.4354 66.3156 24.8103 65.6904C24.1852 65.0653 23.834 64.2175 23.834 63.3334V46.6667",
    stroke: "#F6CA4A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 26.6666L55.58 14.0999C56.0182 13.7349 56.5513 13.5024 57.1169 13.4296C57.6825 13.3568 58.2572 13.4467 58.7735 13.6887C59.2898 13.9308 59.7265 14.3151 60.0323 14.7964C60.338 15.2778 60.5003 15.8363 60.5 16.4066V56.9266C60.5003 57.4968 60.338 58.0554 60.0323 58.5367C59.7265 59.0181 59.2898 59.4023 58.7735 59.6444C58.2572 59.8865 57.6825 59.9764 57.1169 59.9036C56.5513 59.8307 56.0182 59.5982 55.58 59.2332L40.5 46.6666H13.8333C12.9493 46.6666 12.1014 46.3154 11.4763 45.6903C10.8512 45.0651 10.5 44.2173 10.5 43.3332V29.9999C10.5 29.1159 10.8512 28.268 11.4763 27.6429C12.1014 27.0178 12.9493 26.6666 13.8333 26.6666H40.5Z",
    stroke: "#F6CA4A",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.74db25dbaf689316727aa30f17dfd13a.svg";
export { ForwardRef as ReactComponent };